import * as React from 'react';
import OrderListItem from './OrderListItem';
import Section from './Section';
import { Order } from '../order';

const activeOrders = (items: Order[]) => {
  return items.filter((order: Order) => order.status === 'paid');
};

const shippedOrders = (items: Order[]) => {
  return items.filter(
    (order: Order) =>
      order.status === 'shipped' || order.status === 'delivered',
  );
};

const inactiveOrders = (items: Order[]) => {
  return items.filter(
    (order: Order) =>
      order.status !== 'paid' &&
      order.status !== 'shipped' &&
      order.status !== 'delivered',
  );
};

const renderItem = (order: Order, index: number) => (
  <OrderListItem order={order} key={index} index={index} />
);

interface Props {
  items: Order[];
}

export default function OrdersList(props: Props) {
  return (
    <React.Fragment>
      <Section title="Ready to Ship">
        {activeOrders(props.items).map(renderItem)}
      </Section>
      {shippedOrders(props.items).length > 0 && (
        <Section title="Shipped or Delivered">
          {shippedOrders(props.items).map(renderItem)}
        </Section>
      )}
      {inactiveOrders(props.items).length > 0 && (
        <Section title="Cancelled or Refunded">
          {inactiveOrders(props.items).map(renderItem)}
        </Section>
      )}
    </React.Fragment>
  );
}
